"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _VC22SYODcjs = require('../__chunks/VC22SYOD.cjs');
require('../__chunks/I4CBIWTX.cjs');
require('../__chunks/WMTGHDLE.cjs');
require('../__chunks/4TRESXTO.cjs');


exports.createCollectionStore = _VC22SYODcjs.createCollectionStore;
